import regeneratePropertiesForBlockCssRule from './regenerate-properties-for-block-css-rule';

const getUniqProperties = (cssText) => {
  const uniqPropertiesMap = cssText
    .split(';')
    .reduce((map, propertyRule) => map.set(propertyRule.split(':')[0], propertyRule), new Map());
  return [...uniqPropertiesMap.values()].join(';');
};

const generateBlockIdCssRule = ({ stylesheet, blockId, surfaces, blockIdRulesMap }) => {
  const { cssRules } = stylesheet;

  const blockIdRulesCssText = Array.from(blockIdRulesMap.values()).join();

  surfaces.split(' ').forEach((surface) => {
    const blockRuleSelector = `#${blockId} .${surface}`;

    const blockProps = getUniqProperties(blockIdRulesCssText);

    const existingRule = Array.from(cssRules).find(
      (rule) => rule.selectorText === blockRuleSelector
    );

    if (existingRule) {
      // Merge: add new properties that do not already exist in the existing rule
      blockProps.split(';').forEach((prop) => {
        const trimmedProp = prop.trim();

        if (!trimmedProp) {
          return;
        }

        const propName = trimmedProp.split(':')[0].trim();

        if (propName && !existingRule.style.getPropertyValue(propName)) {
          const propValue = trimmedProp.substring(trimmedProp.indexOf(':') + 1).trim();
          existingRule.style.setProperty(propName, propValue);
        }
      });

      regeneratePropertiesForBlockCssRule(existingRule, blockId, surface);
      return;
    }

    const blockRule = `${blockRuleSelector} {${blockProps} }`;
    stylesheet.insertRule(blockRule, cssRules.length);

    const insertedRule = cssRules[cssRules.length - 1];

    regeneratePropertiesForBlockCssRule(insertedRule, blockId, surface);
  });
};

export default generateBlockIdCssRule;
